/*
 * Carrusel horizontal. Lo usan las novedades de la home y el indice de
 * Exhibitions, con el mismo snippet: `snippets/carrusel.liquid`.
 *
 * El carrusel funciona sin esto: es scroll horizontal con scroll-snap, y la
 * tira es enfocable para moverla con las flechas del teclado. Aqui solo se
 * conectan los dos botones y se esconden al llegar a cada extremo, para que
 * no queden como paradas de tabulacion que no hacen nada.
 *
 * Todo se busca DENTRO del propio elemento, asi que dos carruseles en la
 * misma pagina no se pisan.
 */

if (!customElements.get('reda-carrusel')) {
  customElements.define(
    'reda-carrusel',
    class RedaCarrusel extends HTMLElement {
      constructor() {
        super();

        this.tira = this.querySelector('[data-reda-tira]');
        this.anterior = this.querySelector('[data-reda-anterior]');
        this.siguiente = this.querySelector('[data-reda-siguiente]');

        this.pendiente = false;
        this.alHacerScroll = this.alHacerScroll.bind(this);
      }

      connectedCallback() {
        if (!this.tira) return;

        this.tira.addEventListener('scroll', this.alHacerScroll, { passive: true });
        window.addEventListener('resize', this.alHacerScroll, { passive: true });

        if (this.anterior) this.anterior.addEventListener('click', () => this.mover(-1));
        if (this.siguiente) this.siguiente.addEventListener('click', () => this.mover(1));

        this.actualizarFlechas();
      }

      disconnectedCallback() {
        if (this.tira) this.tira.removeEventListener('scroll', this.alHacerScroll);
        window.removeEventListener('resize', this.alHacerScroll);
      }

      alHacerScroll() {
        if (this.pendiente) return;
        this.pendiente = true;
        window.requestAnimationFrame(() => {
          this.actualizarFlechas();
          this.pendiente = false;
        });
      }

      // Un paso es lo que mide el primer elemento mas su separacion, para que
      // el salto caiga siempre donde engancha el scroll-snap.
      paso() {
        const item = this.tira.querySelector('.reda-carrusel__item');
        if (!item) return this.tira.clientWidth * 0.8;

        const hueco = parseFloat(getComputedStyle(this.tira).columnGap) || 0;
        return item.getBoundingClientRect().width + hueco;
      }

      mover(sentido) {
        const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tira.scrollBy({
          left: this.paso() * sentido,
          behavior: suave ? 'smooth' : 'auto',
        });
      }

      actualizarFlechas() {
        if (!this.anterior || !this.siguiente) return;

        const x = this.tira.scrollLeft;
        const maximo = this.tira.scrollWidth - this.tira.clientWidth;

        // Un pixel de margen: los navegadores no siempre llegan al entero.
        this.anterior.hidden = x <= 1;
        this.siguiente.hidden = x >= maximo - 1;
      }
    }
  );
}
